import HousingExpenseRequestComp from "components/housing-expense-request/HousingExpenseRequest";
import React from "react";

const HousingExpenseRequest = () => {
  return (
    <>
      <div className="main-contents">
        <h1>Housing Expense Request</h1>
        <HousingExpenseRequestComp />
      </div>
    </>
  );
};

export default HousingExpenseRequest;
